import React from "react";
import Header from "../components/Header/Header";
import Navbar from "../components/Header/Navbar";
import HeroSlider from "../components/HeroSlider";
import Card from "../components/Card";
import Footer from "../components/Footer";
import MobFooter from "../components/MobFooter";
import { Section1 } from "../components/HomeScreenSections/Section1";
import { Section2 } from "../components/HomeScreenSections/Section2";
import { Section3 } from "../components/HomeScreenSections/Section3";
import { Section4 } from "../components/HomeScreenSections/Section4";

const HomeScreen = () => {
  return (
    <div className="HomeScreen bg-bg-1 ">
      <div>
        
      <Navbar /> 
        sdfsd
      </div>
      <div className="mt-10 font-custom">
      <Section1/>
      <Section2/>
      <Section3/>
      <Section4/>
      </div>
      {/* <Header /> */}
      
      {/* <HeroSlider /> */}

      <Footer/>
      <MobFooter />
    
      {/* apne kam ayega ye mob footer ok  */}
    </div>
  );
};

export default HomeScreen;
